import axios from "axios";
import { References } from './References';
import { HttpRequest, RequestHeaders } from "./HttpRequest";
export default class AuthHelper {    
    public static async IsUserLoggedIn(isMobile: boolean): Promise<any> {
        try {
            const res = await axios.get("/account/CheckAuthorization");
            const { data } = res;
            if (data != null) {
                var isUserAuthorized = data === true;
                var userCredentials;
                
                //Get from browser storage
                userCredentials = AuthHelper.getSavedCredentials();                

                let isUserLicensed = false;
                var userUrl = userCredentials?.url;
                var apiKey = userCredentials?.apiKey;
                if (userUrl != null && apiKey != null) {
                    return new Promise((resolve, reject) => {
                        HttpRequest.get(References.licenseApi)
                        .then(response => {
                            let teamsLicense = response.data?.success?.data?.find(app => app.moduleName === 'microsoft-teams');
                            resolve({
                                isLoggedIn: (isUserAuthorized && userUrl && apiKey),
                                isLicensed: teamsLicense?.status === 'true',
                                url: userUrl,
                                apiKey: apiKey                                
                            })
                        })
                        .catch(error => {                            
                            reject({
                                isLoggedIn: (isUserAuthorized && userUrl && apiKey),
                                isLicensed: false,
                                url: userUrl,
                                apiKey: apiKey  
                            })
                        })
                    })                     
                }
                return {
                    isLoggedIn: (isUserAuthorized && userUrl && apiKey), isLicensed: isUserLicensed, url: userUrl, apiKey: apiKey
                };
            }
        }
        catch (error) {
            console.error(error);
            return {
                isLoggedIn: false, isLicensed: false, url: null, apiKey: null
            };
        }
    }    
    static getSavedCredentials = () => {
        const credentials = new RequestHeaders();
        if (credentials?.url?.length > 0 && credentials?.apiKey?.length > 0) {
            return {
                url: credentials.url,
                apiKey: credentials.apiKey
            }
        }
        return null;
    }
}
